import { datadogRum } from '@datadog/browser-rum';
import {
  simd,
  bigInt,
  bulkMemory,
  exceptions,
  multiValue,
  mutableGlobals,
  referenceTypes,
  saturatedFloatToInt,
  signExtensions,
  tailCall,
  threads,
} from 'wasm-feature-detect';

const reportWebAssemblySupport = async (): Promise<void> => {
  try {
    const supportDetails = {
      simd: await simd(),
      bigInt: await bigInt(),
      bulkMemory: await bulkMemory(),
      exceptions: await exceptions(),
      multiValue: await multiValue(),
      mutableGlobals: await mutableGlobals(),
      referenceTypes: await referenceTypes(),
      saturatedFloatToInt: await saturatedFloatToInt(),
      signExtensions: await signExtensions(),
      tailCall: await tailCall(),
      threads: await threads(),
    };

    datadogRum.addRumGlobalContext('wasm-ready', supportDetails);
  } catch {
    // No errors should be thrown
  }
};

export default reportWebAssemblySupport;
